import styled from 'styled-components';
import { generateContentIconStyle } from '../../icons';

export const StyledRadioInput = styled.div`
  display: flex;
  flex-direction: ${props => props.direction};
  gap: ${props => props.theme.spacing(4)};
  width: 100%;
`;

export const Label = styled.label`
  align-items: center;
  background-color: ${props =>
    props.checked
      ? props.theme.colors.secondary.egg
      : props.theme.colors.status.warningLight};
  border: 1px solid
    ${props =>
      props.error
        ? props.theme.colors.status.errorPrimary
        : props.checked
        ? props.theme.colors.secondary.egg
        : props.theme.colors.border.fur};
  border-radius: 500px;
  color: ${props => props.theme.colors.text.primary};
  cursor: pointer;
  display: grid;
  grid-template-columns: 30px 1fr;
  flex: 1;
  padding: ${props => props.theme.spacing(4)};
  text-align: center;

  ${({ theme }) => theme.typography.body}

  &:hover,
  &:focus-within {
    border: 2px solid
      ${props =>
        props.error
          ? props.theme.colors.status.errorPrimary
          : props.theme.colors.hero.spinach};
    margin: -1px;
  }

  &::before {
    ${props =>
      props.checked
        ? generateContentIconStyle('radiobox-marked')
        : generateContentIconStyle('radiobox-blank')};
    width: 24px;
    height: 24px;
    background-color: ${props => props.theme.colors.border.dark};
  }
`;

export const StyledFieldset = styled.fieldset`
  border-width: 0px;
  width: 100%;
  padding-top: 0px;
  padding-bottom: 0px;
`;

export const StyledLegend = styled.legend`
  position: absolute;
  height: 1px;
  width: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
